import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import useWebhook from '@hooks/useWebhook'
import useWebhooks from '@hooks/useWebhooks'

import WebhookListItem from './WebhookListItem'

const Webhooks = (props) => {
  const { providerId } = props

  const webhooksPayload = useWebhooks({
    filters: { owner_id: providerId, owner_type: 'Provider' },
    performHttpRequests: !!providerId,
  })
  const {
    filteredWebhooks,
    hasFilteredWebhooks,
    loading,
  } = webhooksPayload

  const webhookPayload = useWebhook({ owner_id: providerId, owner_type: 'Provider' })
  const {
    callbacks: { createOrEditWebhook },
  } = webhookPayload

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-webhooks' }}
      loading={loading}
      title="Webhooks"
    >
      <Box flexDirection="column">
        {!loading && !hasFilteredWebhooks && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Webhooks present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please create a Webhook below.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredWebhooks && (
          <DashboardModule.ScrollableSection>
            {filteredWebhooks.map(webhook => (
              <WebhookListItem
                key={webhook.id}
                webhook={webhook}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.Footer boxProps={{ borderTop: loading ? 'none' : '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditWebhook()}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Webhook
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

Webhooks.propTypes = {
  providerId: PropTypes.number.isRequired,
}

export default Webhooks
